import React from "react";
import ReactDOM from "react-dom";

export default function FullscreenLoader() {
  return ReactDOM.createPortal(
    <div className="global-overlay-loader">
      <div className="loader-content">
        
        {/* Company Logo */}
        <img
          src="/assets/mayura.png"
          alt="Company Logo"
          className="loader-logo"
        />

        {/* Animated Loading Text */}
        <p className="loader-text">Please wait<span className="dots"></span></p>

      </div>
    </div>,
    document.body
  );
}
